module.exports = __webpack_public_path__ + "static/media/amazonecho-dot.5efd71cb.png";